import { OnResultDocument, useCreateIndexesMutation } from "../generated";
import { useApolloClient } from "@apollo/client";
import useNewrelic from "./useNewrelic";

const useCreateIndex = () => {
    const { noticeError } = useNewrelic();
    const [createIndexesMutation] = useCreateIndexesMutation();
    const client = useApolloClient();

    const createIndex = async (
        arn: string,
        regionList: string[],
        aggregatorRegion: string,
    ) => {
        const indexcreation = await createIndexesMutation({
            variables: {
              arn, // value for 'arn'
              regionList, // value for 'regionList'
              aggregatorRegion // value for 'aggregatorRegion'
            },
            context: {
              apiName: "resource_explorer"
            },
            notifyOnNetworkStatusChange: true,
        }).then(async ({data}:any) =>{
            let substatus = false;
            const subscriptionPromise = await new Promise((resolve, reject) => {
                client
                ?.subscribe({
                    query: OnResultDocument,
                    variables: {
                        id: data?.createIndexes?.id,
                    },
                })
                .subscribe({
                    next: () => {
                        substatus = true;
                        resolve(
                            true
                        );
                    },
                    error: () => {
                        substatus = false;
                        reject(
                            new Error("Error in Create Index!"),
                        );  
                    },
                });
            }).then(() =>{
                return substatus;
            }).catch(error => {
                noticeError(error.message, "useCreateIndex");
            });
            return subscriptionPromise;
        });
        return {indexcreation};
    };
    return {createIndex};
};

export { useCreateIndex };